export const DEMO_MATRIX_PROFILE_CODES = [
  'demo_restaurant_basic',
  'demo_hotel_basic',
  'demo_spa_basic',
  'demo_fitness_basic',
  'demo_fitness_full',
  'demo_hotel_spa_combo',
  'demo_restaurant_group_multi_location',
  'demo_resort_combo',
  'demo_full_package',
] as const;

const supportedProfiles = new Set<string>(DEMO_MATRIX_PROFILE_CODES);

export const isCanonicalPositiveTenantId = (value: string): boolean =>
  /^[1-9]\d*$/.test(value);

const normalizeTenantId = (value: number | string): string => {
  if (typeof value === 'number') {
    if (!Number.isSafeInteger(value) || value <= 0) {
      throw new Error('Tenant ID must be a positive safe integer.');
    }
    return String(value);
  }
  if (!isCanonicalPositiveTenantId(value)) {
    throw new Error('Tenant ID must be a canonical positive integer.');
  }
  return value;
};

export const buildDemoMatrixApplyPath = (
  tenantId: number | string,
  profileCode: string
): string => {
  const canonicalTenantId = normalizeTenantId(tenantId);
  if (!supportedProfiles.has(profileCode)) {
    throw new Error('Unsupported demo matrix profile.');
  }
  return `/api/v1/super/tenants/${encodeURIComponent(canonicalTenantId)}/demo-matrix/${encodeURIComponent(profileCode)}/apply`;
};
